<template></template>

<script>
import { BROWSER_ERROR } from "@pdfking/translations/enum/errors"

import messages from "../state/messages"

export default {
  methods: {
    initial_action: () => messages.send_error(BROWSER_ERROR),
  },
  mounted() {
    this.initial_action()
  },
}
</script>
